module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Выберите страну":"Select country","Поиск...":"Search...","Ничего не найдено":"Nothing found","Выберите страну...":"Select country..."}}')
  delete Component.options._Ctor
}
